import * as actions from 'actions';
import textEditingMaker from 'reducersMakers/textEditingMaker';

export default textEditingMaker({
  submitType: actions.MAIL_THREAD_MESSAGE_CREATE,
  submitSuccessType: actions.MAIL_THREAD_MESSAGE_CREATE_SUCCESS,
  submitErrorType: actions.MAIL_THREAD_MESSAGE_CREATE_ERROR,
  updateTextType: actions.MAIL_THREAD_MESSAGE_EDITING_UPDATE_TEXT,
  expandType: actions.MAIL_THREAD_MESSAGE_EDITING_EXPAND,
  resetType: actions.MAIL_THREAD_MESSAGE_EDITING_RESET
});



/** WEBPACK FOOTER **
 ** ./src/members/state/mail/textEditing/replyToMessage/reducer.js
 **/